import { ApiError, isApiError } from '@/utils/errors/ApiError';
import { isAbortOrTimeoutError } from '@/utils/requestTimeout';

/** True when the session is invalid and local auth state should be cleared. */
export function isAuthSessionError(error: unknown): boolean {
  if (isApiError(error)) {
    return error.status === 401 || error.status === 403;
  }
  if (!(error instanceof Error)) return false;
  return /session expired/i.test(error.message);
}

/**
 * Transient failures during cold start / network blips — keep local session and let React Query retry.
 * Auth failures are excluded so the user still lands on login when the session is gone.
 */
export function isTransientAuthBootstrapError(error: unknown): boolean {
  if (isAuthSessionError(error)) return false;
  if (isAbortOrTimeoutError(error)) return true;
  if (isApiError(error)) {
    return error.status >= 500 || error.status === 408 || error.status === 429;
  }
  // TypeError from fetch ("Failed to fetch") and similar network failures
  return true;
}

export function toTimeoutApiError(error: unknown): ApiError {
  const message = error instanceof Error ? error.message : 'Request timed out';
  return new ApiError(message || 'Request timed out', 408);
}
